import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalOptions, displayModalComponent } from '../../../../widgets/models';
import { HomeVideoModalComponent } from '../../../../sales-and-delivery/components/home-video-modal/home-video-modal.component';

@Component({
  selector: 'app-tango-Training',
  standalone:true,
  templateUrl: './tango-Training.component.html',
  styleUrls: ['./tango-Training.component.scss']
})
export class TangoTrainingComponent implements OnInit {

  constructor(private modalService: NgbModal) {

  }

  ngOnInit(): void {
  }
  openVideoPopup() {
    let params: any[] = [];
    params.push("ESStory");
    let options: ModalOptions = {
      title: '',
      showSave: false,
      showCancel: true,
      showCross: false,
      showFullscreen: false,
    };

    displayModalComponent(HomeVideoModalComponent, 'lg', options, this.modalService, params);
  }
}
